import { render, staticRenderFns } from "./CopyIntent.vue?vue&type=template&id=4deb90b6&scoped=true&"
import script from "./CopyIntent.vue?vue&type=script&lang=js&"
export * from "./CopyIntent.vue?vue&type=script&lang=js&"
import style0 from "./CopyIntent.vue?vue&type=style&index=0&id=4deb90b6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4deb90b6",
  null
  
)

export default component.exports